import { dispatchAnalyticsEvent } from '../components/analytics/analyticsEvents';

export const useAnalytics = (eventName, defaultEventData = {}) => {
  if (!eventName) {
    throw new Error(
      `Expected useAnalytics("event.name") received event name: "${eventName}"`
    );
  }
  return (eventData = {}) => {
    dispatchAnalyticsEvent(eventName, { ...defaultEventData, ...eventData });
  };
};
